import { ROUTE } from './constants';

export const navigateToHome = () => {
  window.location.href = ROUTE.ROOT;
};

export const navigateToExternalLink = destinationUrl => {
  window.location = destinationUrl;
};
